import { initializeApp } from "firebase/app";
import { RestURL, appName } from "../../lib/utils";
import {
  GoogleAuthProvider,
  getAuth,
  signInWithPopup,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
  sendPasswordResetEmail,
  signOut,
} from "firebase/auth";
import {
  getFirestore,
  query,
  getDocs,
  collection,
  where,
  addDoc,
} from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyCobJNT-Hr_jrmO3mW94R8Fxx4ZWg6yGyA",
  authDomain: "hume-playground.firebaseapp.com",
  projectId: "hume-playground",
  storageBucket: "hume-playground.appspot.com",
  messagingSenderId: "165561716886",
  appId: "1:165561716886:web:29651d9659c8781fcab2b7",
  measurementId: "G-4R5GMSJXG1"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const googleProvider = new GoogleAuthProvider();

const logInWithEmailAndPassword = async (email:string, password:string) => {
  try {
    await signInWithEmailAndPassword(auth, email, password);
  } catch (err:any) {
    console.error(err);
    alert(err.message);
  }
};

const getProfile = async (userId:string) => {
  try {
    if (auth.currentUser == null) return;
    const idToken = await auth.currentUser.getIdToken(true);
    const idUrl = RestURL + "/profile/" + userId
    const response = await fetch (idUrl, {
      method: 'GET',
      headers: {
        authorization: "Bearer " + idToken
      }
    });
    return response.json();
  } catch (err:any) {
    console.error(err);
    alert(err.message);
  }
};

const registerWithEmailAndPassword = async (firstName:string, lastName:string, email:string, password:string) => {
  const body = {
    firstName,
    lastName,
    email,
    password
  };

  const response = await fetch (RestURL, {
    method: 'POST',
    body: JSON.stringify(body)
  });

  if(!response.ok) throw new Error("Problem registering account");
};

const sendPasswordReset = async (email:string) => {
  try {
    await sendPasswordResetEmail(auth, email);
    alert("Password reset link sent!");
  } catch (err:any) {
    console.error(err);
    alert(err.message);
  }
};

const logout = () => {
  signOut(auth);
};

export {
  auth,
  db,
  logInWithEmailAndPassword,
  registerWithEmailAndPassword,
  getProfile,
  sendPasswordReset,
  logout,
};
